import React, { useContext } from "react";
import { View } from "react-native";
import { LocaleContext } from "../../../contexts";
import TextLink from "../../../components/Login/TextLink";
import { loginStyles as styles } from "./styles";

interface LinksProps {
  onRegisterPress: () => void;
  onForgotPasswordPress: () => void;
}

const Links: React.FC<LinksProps> = ({
  onRegisterPress,
  onForgotPasswordPress,
}) => {
  const { t } = useContext(LocaleContext);
  return (
    <View style={styles.linkContainer}>
      <TextLink
        linkTitle={t("loginScreen.needToRegister")}
        onPress={onRegisterPress}
      />
      <TextLink
        linkTitle={t("loginScreen.forgotPassword")}
        onPress={onForgotPasswordPress}
      />
    </View>
  );
};

export default Links;
